import { toast } from "react-toastify";

import { logoutUser } from "../modules/auth";
import { createAction, logAmplitudeEvent } from "../utils";

export const ADD_RECENTLY_COMPLETED_BOOKING =
	"plt-web/bookings/ADD_RECENTLY_COMPLETED_BOOKING";
export const EMPTY_BOOKING = "plt-web/bookings/EMPTY_BOOKING";
const GET_BOOKINGS = "plt-web/bookings/GET_BOOKINGS";
const DETAIL_BOOKING = "plt-web/bookings/DETAIL_BOOKING";
const LOADING_BOOKING = "plt-web/bookings/LOADING_BOOKING";
const GET_SUBSCRIPTIONS = "plt-web/bookings/GET_SUBSCRIPTIONS";
const VERIFY_OFFER = "plt-web/bookings/VERIFY_OFFER";
const VERIFY_OFFER_FINISHED = "plt-web/bookings/VERIFY_OFFER_FINISHED";
const VERIFY_OFFER_ERRORED = "plt-web/bookings/VERIFY_OFFER_ERRORED";

const initialState = {
	data: [],
	recentlyCompletedBooking: null,
	loading: false,
	total: 0,
	detail: {},
	subscriptions: [],
	offerVerificationResult: null,
	offerVerificationError: null,
};

export default function reducer(state, { type, ...action }) {
	if (!state) {
		state = initialState;
	}
	switch (type) {
		case LOADING_BOOKING: {
			return {
				...state,
				data: [],
				detail: {},
				offerVerificationResult: null,
				offerVerificationError: null,
				loading: true,
			};
		}
		case ADD_RECENTLY_COMPLETED_BOOKING: {
			return {
				...state,
				recentlyCompletedBooking: action.data,
			};
		}
		case EMPTY_BOOKING: {
			return {
				...state,
				recentlyCompletedBooking: null,
				offerVerificationResult: null,
				offerVerificationError: null,
			};
		}
		case GET_BOOKINGS: {
			return {
				...state,
				data: action.payload,
				detail: {},
				loading: false,
			};
		}
		case DETAIL_BOOKING: {
			return {
				...state,
				detail: action.payload,
				loading: false,
			};
		}
		case VERIFY_OFFER: {
			return {
				...state,
				offerVerificationResult: null,
				offerVerificationError: null,
			};
		}
		case VERIFY_OFFER_FINISHED: {
			const { payload } = action;
			const succeeded = Boolean(
				!payload?.processed || (payload?.verified && !payload.expired),
			);

			return {
				...state,
				offerVerificationResult: {
					details: action.payload,
					succeeded,
				},
				loading: false,
			};
		}
		case VERIFY_OFFER_ERRORED: {
			console.error("Error verifying offer:", action.payload.error);
			return {
				...state,
				offerVerificationError: action.payload,
				loading: false,
			};
		}
		case GET_SUBSCRIPTIONS: {
			return { ...state, subscriptions: action.payload, loading: false };
		}
		default:
			return state;
	}
}

export const getBookings = (internalApi) => (dispatch) => {
	dispatch(createAction(LOADING_BOOKING));
	internalApi
		.get("v2/customer/me/booking", {})
		.then((response) => {
			dispatch(createAction(GET_BOOKINGS, response));
		})
		.catch((err) => {
			if (err.response) {
				toast.error(
					err?.response?.data?.message || `Error status ${err.response.status}`,
				);
				if (err.response.status === 401) {
					dispatch(logoutUser(internalApi));
				}
			} else {
				console.error("Error listing bookings from Dashboard", err);
			}
		});
};

export const getBookingByReference = (internalApi, reference) => (dispatch) => {
	dispatch(createAction(LOADING_BOOKING));
	internalApi
		.get(`v2/customer/me/booking/${reference}`, {})
		.then((response) => {
			dispatch(createAction(DETAIL_BOOKING, response));
		})
		.catch((err) => {
			console.log(err);
		});
};

export const verifyOffer = (internalApi, data) => (dispatch) => {
	dispatch(createAction(VERIFY_OFFER));
	internalApi
		.post("v2/verify-offer", data)
		.then((response) => {
			dispatch(createAction(VERIFY_OFFER_FINISHED, response));
		})
		.catch((err) => {
			dispatch(createAction(VERIFY_OFFER_ERRORED, { error: err }));
		});
};

export const buildAmplitudeOfferVerificationPayload = (
	offerVerificationResult,
) => {
	const flatten = (obj, prefix = "") => {
		return Object.entries(obj).reduce((acc, [k, v]) => {
			const pre = prefix.length ? `${prefix}.` : "";
			if (typeof v === "object" && v !== null) {
				Object.assign(acc, flatten(v, pre + k));
			} else {
				acc[`${pre}${k}`] = v;
			}
			return acc;
		}, {});
	};

	return flatten(offerVerificationResult, "data.offerVerification");
};
